import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-child" }
const _hoisted_2 = { class: "controller-container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "change width：", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "select sort type：", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("option", { value: "sort" }, "sort", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("option", { value: "switch" }, "switch", -1)
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VDContainer = _resolveComponent("VDContainer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_VDContainer, {
      width: $data.width,
      height: 400,
      row: 4,
      animation: false,
      onGetData: $options.getData,
      data: $data.data,
      type: $data.type
    }, {
      VDC: _withCtx(({ data }) => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", null, _toDisplayString(data.price), 1),
          _createElementVNode("div", null, _toDisplayString(data.name), 1),
          _createElementVNode("div", null, _toDisplayString(data.icon), 1)
        ])
      ]),
      _: 1
    }, 8, ["width", "onGetData", "data", "type"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _hoisted_3,
        _withDirectives(_createElementVNode("input", {
          type: "number",
          step: "50",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.width) = $event))
        }, null, 512), [
          [_vModelText, $data.width]
        ])
      ]),
      _createElementVNode("div", null, [
        _hoisted_4,
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($data.type) = $event))
        }, _hoisted_7, 512), [
          [_vModelSelect, $data.type]
        ])
      ])
    ])
  ], 64))
}